import React, { useState} from "react";
import { TextField} from "@mui/material";
import CodeMirror from "@uiw/react-codemirror";
import {graphQLServices} from "../../../../services/GraphQLServices";
import {LoadingButton} from "@mui/lab";
import {toast} from "react-toastify";
import {VALIDATE_JOB_SETTINGS} from "../graphql/mutations/gqlValidateJobSettings";
import {Processor} from "../../models/JobDefinitionStep";
import {IValidateJobSettingsInput} from "../../models/inputs/ValidateJobSettingsInput";

interface ISettingsEditorProps {
	settings: string;
	setSettings: (query: string) => void;
	processor: Processor;
}

export const JobSettingsEditor: React.FC<ISettingsEditorProps> = (props) => {
	const [response, setResponse] = useState<{ json: any; success: boolean; errors: {message: string}[] }>();
	const [testRequest, setTestRequest] = useState<string>("");
	const [loading, setLoading] = useState(false);
	const verifyQuery = () => {
		setLoading(true);
		const variables: IValidateJobSettingsInput = {
			json: props.settings,
			processor: props.processor,
			testRequest: testRequest === "" ? undefined : testRequest
		};
		graphQLServices.querytoolClient
			.mutate({
				mutation: VALIDATE_JOB_SETTINGS,
				variables: {input: variables},
			})
			.then((result) => {
				setResponse(result.data.validateJobSettings as any);
			})
			.catch(_ => toast.error("Error!"))
			.finally(() => setLoading(false));
	};
	
	const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
		props.setSettings(event.currentTarget.value);
	};
	
	let settingsObject: any;
	
	try{
		settingsObject = JSON.parse(props.settings);
	} catch(e){
		settingsObject = {};
	}
	return (
		<>
			<div
				style={{
					display: "flex",
					justifyContent: "space-between"
				}}
			>
				<div
					style={{
						width: "55%"
					}}
				>
					
					{props.processor === Processor.PythonScript ? (
						<CodeMirror
							value={settingsObject.script}
							minHeight={"500px"}
							onChange={(value) => props.setSettings(JSON.stringify({script: value}))}
						/>
					/*					) : props.processor === Processor. ? (
						<CodeMirror
							value={props.settings}
							height="500px"
							theme={vscodeDark}
							extensions={[json()]}
							onChange={(value) => props.setSettings(value)}
						/>
*/
					) : (
						<TextField
							id="outlined-multiline-static"
							label="Settings"
							multiline
							defaultValue={props.settings}
							sx={{minHeight: "500px", height: "100%", width: "100%"}}
							onChange={handleChange}
						/>
					)}
				</div>
				<div
					style={{
						width: "40%",
					}}
				>
					<LoadingButton loading={loading} fullWidth={true} onClick={verifyQuery}>Verify Settings</LoadingButton>

					<TextField
						label={"Test Request"}
						id="outlined-multiline-static-result"
						multiline
						value={testRequest}
						onChange={(event) => setTestRequest(event.currentTarget.value)}
						sx={{width: "100%", border: "0PX"}}
					/>
					
					<TextField
						label={"Response"}
						id="outlined-multiline-static-result"
						multiline
						value={JSON.stringify(response, null, 4)}
						sx={{width: "100%", border: "0PX"}}
						disabled
					/>
					
				</div>
			</div>
		</>
	);
};
